export default "__VITE_ASSET__CLl8j$Os__"